$(function () {
  async function fetchData() {
    const apiUrl =
      'https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fprtimes.jp%2Fcompanyrdf.php%3Fcompany_id%3D16846&api_key=f9vcqhtsbpoj1m1zxdnyh978t8x4rcyb9mgalyvm';

    try {
      const response = await fetch(apiUrl);

      if (response.ok) {
        const data = await response.json();
        const $postsContainers = document.querySelectorAll(
          '.posts-container-pc'
        );

        // 最新記事順に並び替え
        data.items.sort((a, b) => new Date(b.pubDate) - new Date(a.pubDate));

        for (let i = 0; i < 3 && i < data.items.length; i++) {
          const item = data.items[i];
          const imageUrl = ImageUrl(item.content);
          const date = new Date(item.pubDate);
          const formatDate = `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`;

          $postsContainers.forEach(($postsContainer) => {
            const $post = document.createElement('li');
            $post.classList.add('post');
            $post.innerHTML = `
            <a href="${item.link}" class="post-link" target="_blank">
              <div class="post-image">
                <img src="${imageUrl}" alt="記事の画像">
              </div>
              <div class="post-details">
                <div class="post-date">${formatDate}</div>
                <h2 class="post-title">${item.title}</h2>
              </div>
            </a>
          `;
            $postsContainer.appendChild($post);
          });
        }
        var w_w = $(window).width();
        var path = location.pathname;
        if (path === '/' && w_w <= 749) {
          $('.posts-container-pc').slick({
            infinite: true,
            dots: true,
            centerPadding: '20%',
            slidesToShow: 1.4,
            slidesToScroll: 1,
            centerMode: true,
            variableWidth: true,
          });
        } else if (path === '/' && w_w >= 750) {
          $('.posts-container-pc').slick({
            infinite: true,
            dots: true,
            centerPadding: '20%',
            slidesToShow: 2.4,
            slidesToScroll: 1,
            centerMode: true,
            variableWidth: true,
          });
        }
      } else {
        console.error('Failed to fetch data:', response.status);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  // 取得したcontentデータの文字列をなくす
  function ImageUrl(content) {
    const regex = /\[画像\d+: (.*?) \]/; // URL抽出する正規表現
    const match = content.match(regex);
    return match ? match[1] : '';
  }

  fetchData();
});
